import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Table from "../../../../core/pagination/datatable";
import { Spin, Modal, Input } from "antd";
// import EditDryerEquip from "./EditDryerEquip";
import axios from "axios";
import {
  getApiBaseUrl,
  GET_ASSET_TYPE,
  UPDATE_ASSET_TYPE_STATUS,
  ADD_ACTIVITY,
  LOGIN,
} from "../../Config/Config";
import NewFilterType from "./NewFilterType";
import EditFilterType from "./EditFilterType";
import Swal from "sweetalert2";

const FilterTypes = () => {
  const user = JSON.parse(sessionStorage.getItem("user"));

  const [filterTypeData, setFilterTypeData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedFilterType, setSelectedFilterType] = useState();
  const [deleteLoading, setDeleteLoading] = useState(false);

  const [reauthVisible, setReauthVisible] = useState(false);
  const [password, setPassword] = useState("");
  const [passwordError, setPasswordError] = useState("");
  // const [loading, setLoading] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState(null);

  const fetchAssetTypes = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${getApiBaseUrl()}${GET_ASSET_TYPE}`);
      if (response.data && response.data.Status) {
        setFilterTypeData(response.data.ResultData);
      } else {
        console.error("API returned error status");
      }
    } catch (error) {
      console.error("Error fetching Filter types:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAssetTypes();
  }, []);

  // const handleDeleteAssetType = async (record) => {
  //   const logActivity = async (isSuccess, note) => {
  //     try {
  //       await fetch(`${getApiBaseUrl()}${ADD_ACTIVITY}`, {
  //         method: "POST",
  //         headers: { "Content-Type": "application/json" },
  //         body: JSON.stringify({
  //           ActivityType: 1,
  //           PerformedBy: user.UserID,
  //           PerformedOn: new Date()
  //             .toISOString()
  //             .slice(0, 19)
  //             .replace("T", " "),
  //           Notes: note,
  //           Location: "Asset Type Management",
  //           IsSucces: isSuccess ? 1 : 0,
  //         }),
  //       });
  //     } catch (err) {
  //       console.error("Error logging activity:", err);
  //     }
  //   };

  //   const result = await Swal.fire({
  //     title: `Delete "${record.AssetType}"?`,
  //     text: "This action cannot be undone.",
  //     icon: "warning",
  //     showCancelButton: true,
  //     confirmButtonColor: "#d33",
  //     cancelButtonColor: "#6c757d",
  //     confirmButtonText: "Yes, delete it",
  //   });

  //   if (result.isConfirmed) {
  //     setDeleteLoading(true);
  //     try {
  //       const response = await fetch(
  //         `${getApiBaseUrl()}${UPDATE_ASSET_TYPE_STATUS}`,
  //         {
  //           method: "POST",
  //           headers: { "Content-Type": "application/json" },
  //           body: JSON.stringify({
  //             id: record.Id,
  //             Updatedby: user.UserID,
  //             IsActive: 0,
  //           }),
  //         }
  //       );

  //       const data = await response.json();
  //       setDeleteLoading(false);

  //       if (response.ok && data.Status === true) {
  //         await Swal.fire(
  //           "Deleted!",
  //           "Filter type has been deleted.",
  //           "success"
  //         );
  //         await logActivity(1, `Deleted asset type "${record.AssetType}"`);
  //         fetchAssetTypes();
  //       } else {
  //         await Swal.fire(
  //           "Error",
  //           `Failed to delete "${record.AssetType}".`,
  //           "error"
  //         );
  //         await logActivity(
  //           0,
  //           `Failed to delete asset type "${record.AssetType}"`
  //         );
  //       }
  //     } catch (error) {
  //       console.error("Error deleting Filter type:", error);
  //       await Swal.fire(
  //         "Error",
  //         `Failed to delete filter type "${record.AssetType}".`,
  //         "error"
  //       );
  //       await logActivity(
  //         0,
  //         `Failed to delete asset type "${record.AssetType}"`
  //       );
  //     } finally {
  //       setDeleteLoading(false);
  //     }
  //   }
  // };

  const handlePasswordSubmit = async () => {
    if (!password) {
      setPasswordError("Please enter your password");
      return;
    }

    setLoading(true);
    setPasswordError("");
    const username = user?.UserName || user?.Username;
    let loginSuccessful = false;

    try {
      const loginRes = await fetch(`${getApiBaseUrl()}${LOGIN}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username, password }),
      });

      const loginData = await loginRes.json();

      if (loginData?.Message === "Login successful") {
        loginSuccessful = true;
      } else {
        setPasswordError(
          "Reauthentication failed. Please check your password."
        );
      }
    } catch (error) {
      console.error(error);
      setPasswordError("Something went wrong. Please try again.");
    }

    // Always log activity
    const logActivity = async (isSuccess, note) => {
      try {
        await fetch(`${getApiBaseUrl()}${ADD_ACTIVITY}`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            ActivityType: 1,
            PerformedBy: user.UserID,
            PerformedOn: new Date()
              .toISOString()
              .slice(0, 19)
              .replace("T", " "),
            Notes: note,
            Location: "Filter Type ",
            IsSucces: isSuccess ? 1 : 0,
          }),
        });
      } catch (err) {
        console.error("Error logging activity:", err);
      }
    };

    setLoading(false);

    if (loginSuccessful) {
      setReauthVisible(false);
      setPassword("");

      // ✅ Proceed with delete only after successful reauth
      Swal.fire({
        title: `Delete "${selectedRecord.AssetType}"?`,
        text: "This action cannot be undone.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#6c757d",
        confirmButtonText: "Yes, delete it",
      }).then(async (result) => {
        if (result.isConfirmed) {
          setDeleteLoading(true);
          try {
            const response = await fetch(
              `${getApiBaseUrl()}${UPDATE_ASSET_TYPE_STATUS}`,
              {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                  id: selectedRecord.Id,
                  Updatedby: user.UserID,
                  IsActive: 0,
                }),
              }
            );

            const data = await response.json();
            setDeleteLoading(false);

            if (response.ok && data.Status === true) {
              await Swal.fire(
                "Deleted!",
                "Filter type has been deleted.",
                "success"
              );
              await logActivity(
                1,
                `Deleted filter type "${selectedRecord.AssetType}"`
              );
              fetchAssetTypes();
            } else {
              await Swal.fire(
                "Error",
                `Failed to delete "${selectedRecord.AssetType}".`,
                "error"
              );
              await logActivity(
                0,
                `Failed to delete filter type "${selectedRecord.AssetType}"`
              );
            }
          } catch (error) {
            console.error("Error deleting filter type:", error);
            await Swal.fire(
              "Error",
              `Failed to delete filter type "${selectedRecord.AssetType}".`,
              "error"
            );
            await logActivity(
              0,
              `Failed to delete filter type "${selectedRecord.AssetType}"`
            );
          } finally {
            setDeleteLoading(false);
          }
        }
      });
    } else {
      await logActivity(
        0,
        `Failed Reauthentication for deleting filter type "${selectedRecord.AssetType}" by ${username}`
      );
    }
  };

  const columns = [
    {
      title: "Filter Type",
      dataIndex: "AssetType",
      key: "AssetType",
      sorter: (a, b) => a.AssetType.localeCompare(b.AssetType),
    },
    {
      title: "Description",
      dataIndex: "Note",
      key: "Note",
      render: (note) => note || "—",
      sorter: (a, b) => (a.Note || "").localeCompare(b.Note || ""),
    },
    {
      title: "Actions",
      key: "actions",
      align: "center",
      render: (_, record) => (
        <div className="action-table-data">
          <div className="edit-delete-action d-flex align-items-center">
            <Link
              to="#"
              className="me-2"
              data-bs-toggle="offcanvas"
              data-bs-target="#EditAssetTypeOffcanvas"
              onClick={() => setSelectedFilterType(record)}
              title="Edit"
            >
              <i data-feather="edit" className="feather-edit text-info"></i>
            </Link>
            {/* <Link
              to="#"
              className="me-2"
              onClick={() => handleDeleteAssetType(record)}
              title="Delete"
            >
              <i data-feather="trash" className="feather-trash text-danger"></i>
            </Link> */}
            <Link
              to="#"
              className="me-2"
              onClick={() => {
                setSelectedRecord(record);
                setReauthVisible(true);
              }}
              title="Delete"
            >
              <i data-feather="trash" className="feather-trash text-danger"></i>
            </Link>
          </div>
        </div>
      ),
    },
  ];
  console.log(selectedFilterType);

  return (
    <>
      {deleteLoading && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
          style={{
            zIndex: 1050,
            backdropFilter: "blur(4px)",
            backgroundColor: "rgba(255, 255, 255, 0.2)", // subtle tint
          }}
        >
          <Spin size="large" tip="Processing..." />
        </div>
      )}
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/assetmgt/dashboard">
                        <i className="fas fa-home fa-lg" />
                      </Link>
                    </li>
                    <h4 className="breadcrumb-item " aria-current="page">
                      Filter Types
                    </h4>
                  </ol>
                </nav>
                <h6>Manage Filter Types</h6>
              </div>
            </div>

            <div className="page-btn">
              <Link
                data-bs-toggle="offcanvas"
                data-bs-target="#AddAssetTypeOffcanvas"
                aria-controls="AddAssetTypeOffcanvas"
                className="btn btn-success btn-sm"
              >
                <i className="ti ti-circle-plus fs-4"></i>
              </Link>
            </div>
          </div>

          <div>
            <div className="card table-list-card">
              <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3  ">
                <div className="search-set mt-4"></div>
                <div className="d-flex table-dropdown my-xl-auto right-content align-items-center flex-wrap row-gap-3"></div>
              </div>
              <div className="card-body">
                <div className="table-responsive">
                  {loading ? (
                    <div className="text-center my-4">
                      <Spin size="large" />
                      <p>Loading data...</p>
                    </div>
                  ) : filterTypeData.length > 0 ? (
                    <Table dataSource={filterTypeData} columns={columns} />
                  ) : (
                    <p className="text-center my-4">No data available</p>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <NewFilterType />
        <EditFilterType selectedFilterType={selectedFilterType} />

        <Modal
          title="Confirm Password"
          open={reauthVisible}
          onOk={handlePasswordSubmit}
          onCancel={() => setReauthVisible(false)}
          confirmLoading={loading}
          width={350}
        >
          <Spin spinning={loading}>
            <Input.Password
              placeholder="Enter your password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="new-password"
              onCopy={(e) => e.preventDefault()}
              onPaste={(e) => e.preventDefault()}
              onCut={(e) => e.preventDefault()}
            />
            {passwordError && (
              <div className="text-danger mt-2">{passwordError}</div>
            )}
          </Spin>
        </Modal>
      </div>
    </>
  );
};

export default FilterTypes;
